import { render, staticRenderFns } from "./DetailListViewContainer.vue?vue&type=template&id=51cfc09f"
import script from "./DetailListViewContainer.vue?vue&type=script&lang=js"
export * from "./DetailListViewContainer.vue?vue&type=script&lang=js"
import style0 from "./DetailListViewContainer.vue?vue&type=style&index=0&id=51cfc09f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports